<template>
    <div>
        <h2>{{$t('screening-upload.picture.headline')}}</h2>
        <p class="text">
            {{$t('screening-upload.picture.description')}}
        </p>
        <div class="seperator"></div>
        <div v-if="!uploadedPicture">

            <div class="profile-pic-placeholder"></div>

            <button v-on:click="showUpload = true;" class="purple upload-button">{{$t('button.upload.label')}}</button>

            <my-upload field="image"
                @crop-success="cropSuccess"
                @crop-upload-success="uploadSuccess"
                @crop-upload-fail="customUploadError"
                v-model="showUpload"
                langType="en"
                :langExt="daLang"
                :noCircle="true"
                :url="uploadImageUrl"
                :params="cropParams"
                :headers="uploadImageHeaders"
                img-format="png/jpg">
                <img :src="uploadedPicture">
            </my-upload>


            <!-- <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"
                @vdropzone-success="uploadSuccess"
                @vdropzone-error="customUploadError"
                class="dropzone profile-pic"></vue-dropzone> -->
        </div>
        <div v-else>
            <!-- <div v-if="cropOpen">
                cropper:
                <img :src="uploadedPicture" />
            </div> -->
            <div class="pb">
                <img :src="uploadedPicture" alt="image">
            </div>
            <p class="delete" @click.prevent="deleteImage">{{$t('screening-upload.picture.delete')}}</p>
        </div>
    </div>
</template>

<script>

    import {mapGetters} from 'vuex';
    import Vue from 'vue';
    import myUpload from 'vue-image-crop-upload';
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'

    export default {
        components: {
            vueDropzone: vue2Dropzone,
            myUpload
        },
        data: () => ({
            dropzoneOptions: {},
            uploadedPicture: '',
            backgroundImage: '',
            cropOpen: true,
            cropParams: {
                name: 'image'
            },
            showUpload: false
        }),
        computed:{
            ...mapGetters([
                'getToken',
                'getPictureUrl'
            ]),
            uploadImageUrl() {
                return window.config.apiUrl + 'api/user/image';
            },
            uploadImageHeaders() {
                return {
                    'Authorization': "Bearer " + this.getToken
                };
            },
            daLang() {
                return {
                    hint: this.$t('image-upload.dragdrophere.label'),
                    loading: this.$t('image-upload.uploading.label'),
                    success: this.$t('image-upload.successfull.label'),
                    fail: this.$t('image-upload.failed.label'),
                    preview: this.$t('image-upload.preview.label'),
                    btn: {
                        off: this.$t('button.cancel.label'),
                        close: this.$t('button.close.label'),
                        back: this.$t('button.back.label'),
                        save: this.$t('button.save.label')
                    }
                }
            }
        },
        methods: {
            cropSuccess() {

            },
            openCrop() {
                this.cropOpen = true;
            },
            customUploadError(data) {
                if(data.xhr !== null && (data.xhr.status === 401 || data.xhr.status === 403)) {
                    this.$store.commit('setToken', null)
                    return;
                }

                if (typeof data.xhr == 'undefined') {
                    this.$swal(this.$t('general.unknown-error.label'), [], 'error');

                    return;
                }
                let response = JSON.parse(data.xhr.responseText);
                this.$swal(this.$t(response.message), [], 'error');
            },
            hasUploadedPicture() {
                return this.getPictureUrl ? true : false;
            },
            uploadSuccess(file, response){
                // this.uploadedPicture = response;
                // this.backgroundImage = "url('" +  response + "')";
                this.$root.$emit('tab', 'verifyIdentity', false);
                this.$store.dispatch('fetchScreeningStatus');
                this.reloadImage();
            },
            deleteImage(){
                axios({
                    method: 'DELETE',
                    url: window.config.apiUrl + 'api/user/image',

                }).then(response => {
                    this.uploadedPicture = '';
                    this.$store.dispatch('fetchScreeningStatus');
                });
            },
            reloadImage() {
                axios({
                    method: 'GET',
                    url: window.config.apiUrl + 'api/user/image',

                }).then(response => {
                    this.uploadedPicture = response.data;
                    this.backgroundImage = "url('" +  response.data + "')";
                });
            }
        },
        created(){
            this.dropzoneOptions = {
                url: window.config.apiUrl + 'api/user/image',
                thumbnailWidth: 150,
                maxFilesize: 10,
                paramName: 'image',
                headers: {
                    'Authorization': 'Bearer ' + this.getToken
                },
                autoProcessQueue: true,
                dictDefaultMessage: 'Drop files here to upload or click to browse',
                uploadMultiple: false,
                acceptedFiles: 'image/*',
                error: function(file, error) {
                    this.$swal(error.message, [], 'error');
                    this.removeAllFiles();
                }
            };
            this.$store.dispatch('fetchProfileImage').then(
                () => {
                    this.uploadedPicture = this.getPictureUrl;
                    this.backgroundImage = "url('" +  this.getPictureUrl + "')";
                    if(this.getPictureUrl){
                        this.$root.$emit('tab', 'verifyIdentity', false);
                    }
                }
            );
            this.dropzoneOptions.dictDefaultMessage = this.$t('upload-pb.placeholder');
        }
    }
</script>

<style>

</style>
